import classNames from "classnames";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { st, Modal, Button, MainView } from "lib/index";
import OrderScheduleForm from "modules/orders/OrderScheduleForm/OrderScheduleForm";
import { stateSelector, open, close, updateOrder, validate, submit, fetchSlotsData } from "./index";

@connect(
  (state) => ({
    opened: stateSelector(state).opened,
    order: stateSelector(state).form.model,
    valid: stateSelector(state).form.valid,
    errors: stateSelector(state).form.errors,
    submitLoading: stateSelector(state).form.submitLoading,
    slots: stateSelector(state).slotsData.model,
    fetchDone: stateSelector(state).slotsData.fetchDone,
    fetchLoading: stateSelector(state).slotsData.fetchLoading,
    fetchFailed: stateSelector(state).slotsData.fetchFailed,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        open,
        close,
        updateOrder,
        validate,
        submit,
        refetch: fetchSlotsData,
      },
      dispatch
    )
)
export default class ChangeOrderScheduleSlotModal extends React.PureComponent {
  render() {
    const {
      opened,
      order,
      valid,
      errors,
      submitLoading,
      slots,
      fetchDone,
      fetchLoading,
      fetchFailed,
      close,
      updateOrder,
      validate,
      submit,
      refetch,
    } = this.props;
    const canCreateCustomSlot =
      opened && order && st.authorize("create", { type: "ProductScheduleSlot", company_id: order.company.id });
    return (
      opened && (
        <Modal closeIcon closeOnDimmerClick={false} open onClose={() => close()}>
          <Modal.Header>{I18n.t("papp.orders.ChangeOrderScheduleSlotModal.title")}</Modal.Header>
          <Modal.Content style={{ minHeight: "500px" }}>
            <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={refetch} />
            {fetchDone && (
              <OrderScheduleForm
                order={order}
                slots={slots}
                loading={submitLoading}
                valid={valid}
                errors={errors}
                onValidate={validate}
                onOrderUpdate={updateOrder}
                onSave={submit}
                autosaveOnSlotSelect={false}
                canCreateCustomSlot={canCreateCustomSlot}
              />
            )}
          </Modal.Content>
          <Modal.Actions>
            <Button as="a" basic onClick={close} disabled={submitLoading} content={I18n.t("papp.common.cancel")} />
            <Button as="a" primary onClick={submit} disabled={submitLoading} content={I18n.t("papp.common.save")} />
          </Modal.Actions>
        </Modal>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/orders/ChangeOrderScheduleSlotModal/ChangeOrderScheduleSlotModal.jsx